// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./background-colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* started RDMupload design */

button.btn-download {
    background-color: var(--download-btn-bg-color);
    color: var(--download-btn-txt-color);
    box-shadow: var(--button-box-shadow);
}

button.btn-preview {
  background-color: var(--button-custom-one);
  color: var(--whitefont-color);
  box-shadow: var(--button-custom-one-shadow);
}

button.btn-reset-button {
  background-color: var(--button-background);
  color: var(--whitefont-color);
  box-shadow: var(--button-box-shadow);
}



button.btn-preview:hover {
  background-color: var(--button-custom-one-hover);
  color: var(--whitefont-color);
}

button.btn-reset-button:hover {
  background-color: var(--button-background);
  color: var(--whitefont-color);
}


button.Upload-btn-color{
  background-color: var(--Upload-btn-bg-color);
  color: var(--Upload-btn-txt-color);
}


button.Upload-btn-color:hover{
  background-color: var(--Upload-btn-bg-color);
  color: var(--Upload-btn-txt-color);
}



button.btn-Upload {
  background-color: var(--button-background);
  color: var(--whitefont-color);
  box-shadow: var(--button-box-shadow);
}


button.btn-cancel {
  background-color: var(--button-custom-two-cancel);
  color: var(--whitefont-color);
  box-shadow: var(--button-custom-two-shadow);
}

button.btn-cancel:hover {
  background-color: var(--button-custom-two-hover);
  color: var(--whitefont-color);
}

.RDMupload-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: space-between; /* it will give space between header and footer */
  background-color: #eaeaeb;
}


.container-upload {
  background-color:  #FFFFFF;
  padding: 5px;
  border-radius: 10px;

}

/* .Demupload-card-header-1 {
  background-color: #ffffff !important;
  color: rgb(0, 0, 0);
} */

.breadcrumb-item + .breadcrumb-item::before {
  content: ">";
  color: #6c757d; /* Optional: Adjust the color */
}



.text-color{
  color: var(--Uplaod-h5-text-color);
}

.table-number-FS{
  font-size: var(--table-number-font-size);
}

.checksum-details
{
  font-size:var(--checksum-deatils-font-size);
  color:black ;
  display: flex;
  flex-wrap: wrap;
  gap: 1px;
}



.backbutton-uplaod{
margin-top: 10px;
}

.card-demupload {
  height: 79vh;
}


.txt-margin-top{
  margin-top: .7rem;
  margin-left: 0.08rem;
}

.txt-margin-left{
  /* margin-top: .7rem; */
  margin-left: 0.05rem;
  color: #0a66c2;
}
.down-btn-left{
margin-left: 0.3rem;
}

.browse-mar{
  margin-left: 0.40rem;
}


.browse-mar1{
  margin-left: 0.05rem;
}
.download-btn {
  margin-left: 0.4rem;
}

.download-text-btn
{
  margin-left: 0.2rem;
}


.brow-box-btn
{
  margin-left: 0.3rem;
}



/* .vertical-line-border{

  width: 2px; 
 background-color: #ccc;
  margin-Top: 20px;
  margin-bottom: 11px; 
} */

.vertical-line-border-1{

  width: 2px; 
 background-color: #ccc;
  /* margin-Top: 20px; */
  margin-bottom: 11px; 
  height: 400px;
}

.card-shawdow-demuplaod
{

  /* height: 58ch; */
  background-color: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075); /* Equivalent to Bootstrap shadow-sm */
  border: none;
  display: flex;
  flex-direction: column;
}


/* Apply styles only within the "supported-file-formats" section */
.supported-file-formats .format-item {
  margin-bottom: 0.5rem; /* Equivalent to Bootstrap's mb-2 */
  display: flex;
  align-items: center;
  cursor: pointer;
}


.custom-vertical-line {
  height: 100%;
  width: 2px;
  min-height: 460px;
  background-color: #ccc;
}



/* Custom class for the overall upload section */
.custom-upload-section {
  display: flex;
  width: 100%;
  align-items: center;
}

/* Custom class for buttons container */
.custom-upload-buttons {
  margin-left: auto; /* Aligns buttons to the right */
  text-align: end;
}

/* Custom class for cancel button */
.custom-cancel-button {
  margin-top: 8px;
  text-align: end;
}

/* Optional: Add spacing between buttons */
.custom-upload-buttons button {
  margin-left: 10px;
}
/* Custom dropdown menu styles */
.custom-dropdown-menu {
  max-height: 80px;
  overflow-y: auto;
  min-width: 180px;
}



/* Container for the file upload */
.custom-file-upload-container {
  position: absolute;
  top: 39%;
  right: 315px;
  z-index: 10;
  width: 349px;
  height: 140px;
}


.custom-file-upload-container-1 {
  position: absolute;
  top: 24%;
  right: 315px;
  z-index: 10;
  width: 349px;
  height: 140px;
}

/* Box styling for file upload */
.custom-file-upload-box {
  width: 100%;
  height: 100%;
  padding: 1rem;
  border-radius: 8px;
  background-color: #fff;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}

/* Button styling */
.custom-file-button {
  max-width: 200px;
}


/* Custom dropdown button */
.custom-dropdown-btn {
  background-color: #f8f9fa; /* Light gray background */
  color: #333; /* Dark text */
  border: 1px solid #ccc; /* Light border */
}

/* Hover effect */
.custom-dropdown-btn:hover {
  background-color: #e9ecef; /* Slightly darker gray */
  border-color: #bbb;
}

/* Disabled button styling */
.custom-dropdown-btn:disabled {
  background-color: #d6d6d6;
  color: #888;
  border-color: #d6d6d6;
}

/* Hide the actual file input */
.custom-hidden-file-input {
  display: none;
}


#noHoverDropdown:hover,
#noHoverDropdown:focus {
  background-color: transparent !important; /* Prevent background color change */
  border-color: #6c757d !important; /* Keep the default border */
  color: inherit !important; /* Retain the text color */
}



.Demuplad-custom-card{
  
  max-width: 900px; /* Adjust width as needed */
  max-height: 450px; /* Adjust height to reduce size */
  border-radius: 8px; /* Smooth rounded corners */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Soft shadow effect */
  overflow: hidden; /* Prevents content from overflowing */
  background-color: #ffffff; /* White background */
}

/* .dem-header-name{
  color: rgb(0, 0, 0);
} */

.wrapper {
    margin: auto;
    max-width: 400px;
    padding-top: 60px;
    text-align: center;
  }
  
  .container {
    padding: 0px;
    border-radius: 10px;
  }
  
  h1 {
    color: #0f2d40;
    /* font-family: 'Varela Round', sans-serif; */
    letter-spacing: -.5px;
    font-weight: 100;
    padding-top:  10px;
  }
  
  .upload-container {
    background-color: rgb(239, 239, 239);
    border-radius: 6px;
    padding: 10px;
  }

  /* Custom Dropdown Styling */
.custom-dropdown {
  position: relative;
  display: inline-block;
}


/* Hide dropdown by default */
.custom-dropdown-menu {
  display: none;
  position: absolute;
  left: 83px;
  background-color: white;
  top: 1px;
  border-radius: 6px;
  min-width: 150px;
  max-height: 110px;
  border: 1px solid #ccc;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  padding: 4px 0;
  list-style: none;
  z-index: 1000;
  transition: all 0.3s ease-in-out;
}


/* Show dropdown when hovering */
.custom-dropdown:hover .custom-dropdown-menu {
  display: block;
  opacity: 1;
  transform: translateY(-5px);
}

/* Dropdown Item Styling */
.custom-dropdown-item {
  background: none;
  border: none;
  padding: 5px 6px;
  width: 100%;
  text-align: left;
  font-size: 10px;
  color: #333;
  cursor: pointer;
  transition: background 0.3s ease;
  display: block;
}

/* Hover Effect on Dropdown Items */
.custom-dropdown-item:hover {
  /* background: #26b7ec; */
  color: rgb(0, 0, 0);
  border-radius: 4px;
}

/* Custom Dropdown Styling for Sheet Selection */


/* Dropdown Menu */
/* .custom-dropdown-menu-sheet {
  display: none;
  position: absolute;
  left: 83px;
  background-color: white;
  top: 5px;
  border-radius: 6px;
  min-width: 100%;
  max-height: calc(5 * 22px); 
  overflow-y: auto; 
  border: 1px solid #ccc;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  padding: 0.5rem 0;
  list-style: none;
  z-index: 1000;
  transition: all 0.3s ease-in-out;
} */
/* .custom-dropdown-menu-sheet {
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  left: 83px;
  top: 5px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
  padding: 0.5rem 0;
  z-index: 1000;
  width: fit-content; 
  min-width: 100%; 
  white-space: nowrap; 
} */



/* Show dropdown on hover */
.custom-dropdown-sheet:hover .custom-dropdown-menu-sheet {
  display: block;
  opacity: 1;
  transform: translateY(-5px);
}

/* Dropdown Item Styling */
.custom-dropdown-item-sheet {
  background: none;
  border: none;
  padding: 4px 6px;
  width: 100%;
  text-align: left;
  font-size: 10px;
  color: #333;
  cursor: pointer;
  transition: background 0.3s ease;
  display: block;
  white-space: nowrap; /* Prevent text wrapping */
}

/* Hover Effect on Dropdown Items */
.custom-dropdown-item-sheet:hover {
  /* background: #26b7ec; */
  color: rgb(0, 0, 0);
  border-radius: 4px;
}

/* Custom Scrollbar */
.custom-dropdown-menu-sheet::-webkit-scrollbar {
  width: 6px;
}

.custom-dropdown-menu-sheet::-webkit-scrollbar-thumb {
  /* background-color: #26b7ec; */
  border-radius: 4px;
}

.custom-dropdown-menu-sheet::-webkit-scrollbar-track {
  background: #f1f1f1;
}

 .custom-dropdown-menu {

  opacity: 1;
  transform: translateY(0);
  transition: all 0.3s ease-in-out;
} 


.header-five{
  margin-left: 4px;
}
  
  .border-container {
    border: 5px dashed rgba(198, 198, 198, 0.65);
  /*   border-radius: 4px; */
    padding: 1px;
  }
  
  .border-container p {
    color: #130f40;
    font-weight: 600;
    font-size: 1.1em;
    letter-spacing: -1px;
    margin-top: 30px;
    margin-bottom: 0;
    opacity: 0.65;
  }
  
  #file-browser {
    text-decoration: none;
    color: rgb(22,42,255);
    border-bottom: 3px dotted rgba(22, 22, 255, 0.85);
  }
  
  #file-browser:hover {
    color: rgb(0, 0, 255);
    border-bottom: 3px dotted rgba(0, 0, 255, 0.85);
  }
  
  .icons {
    color: #95afc0;
    opacity: 0.55;
  }
  
  .selected-file {
    color: #db34a3; /* Change color as desired */
    font-size: 5px; /* Change font size as desired */
    position: absolute;
    top: 10%;
    left: 10%;
    transform: translate(-20%, -20%);
  }
  
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8); /* Semi-transparent white */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  
   .foot-rdmup
    {
      margin-top: 20px;
    }

/* Preview Table design  */
.table-name{
color: var(--table-header-color);
}

.total-number{
  color: var(--table-numbers-color);
}
.dropdown-button-color
{
  background-color: var(--dropdown-button-background);
  color: var(--whitefont-color);
}
.columns-dropdown
{
  color: var(--blackfont-color);
} 

.table-footer-color {
  font-weight: bold !important;
  background-color: var(--table-footer-color) !important;
  color: var(--whitefont-color) !important;
  text-align: right !important;
  padding-right: 10px !important;
}

.table-footer-details {
background-color: var(--table-footer-color);
  position: sticky;
  bottom: 0;
  z-index: 1;
}

.preview-btn-color
{
  background-color: var(--Preview-btn-bg-color);
  color: var(--preview-btn-txt-color);
}



.cancel-btn-color
{
background-color: var(--cancel-btn-bg-color);  
color: var(--cancel-btn-txt-color);
}

.Preview-table-name {
  font-size: var(--table-name-font-size);
  font-weight: bold;
  margin: 0;
}

.validation-text{
  color: green;
  font-size: var(--preview-validation-font-size);
  font-weight: bold;
}

button.Scan-preview-btn-color{
  background-color: var(--ScanandPreview-btn-bg-color);
  color: var(--Scanandpreview-btn-txt-color);
  box-shadow: var(--button-box-shadow);
   }
/*  
   button.Scan-preview-btn-color:hover {
     background-color: var(--ScanandPreview-btn-bg-color);
     color: var(--Scanandpreview-btn-txt-color);
   }
  */


   button.Scan-preview-btn-color:hover,
   button.Scan-preview-btn-color:active,
   button.Scan-preview-btn-color:focus {
     background-color: var(--ScanandPreview-btn-bg-color) !important;
     color: var(--Scanandpreview-btn-txt-color) !important;
     border-color: var(--ScanandPreview-btn-bg-color) !important; /* Optional */
     box-shadow: none !important; /* Optional: removes Bootstrap glow */
 }
 



  /* ended RDMupload design */
  
  
  `, "",{"version":3,"sources":["webpack://./src/assets/css/RDMupload.css"],"names":[],"mappings":"AAEA,6BAA6B;;AAE7B;IACI,8CAA8C;IAC9C,oCAAoC;IACpC,oCAAoC;AACxC;;AAEA;EACE,0CAA0C;EAC1C,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;EAC1C,6BAA6B;EAC7B,oCAAoC;AACtC;;;;AAIA;EACE,gDAAgD;EAChD,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,6BAA6B;AAC/B;;;AAGA;EACE,4CAA4C;EAC5C,kCAAkC;AACpC;;;AAGA;EACE,4CAA4C;EAC5C,kCAAkC;AACpC;;;;AAIA;EACE,0CAA0C;EAC1C,6BAA6B;EAC7B,oCAAoC;AACtC;;;AAGA;EACE,iDAAiD;EACjD,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,gDAAgD;EAChD,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,8BAA8B,EAAE,iDAAiD;EACjF,yBAAyB;AAC3B;;;AAGA;EACE,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;;AAErB;;AAEA;;;GAGG;;AAEH;EACE,YAAY;EACZ,cAAc,EAAE,+BAA+B;AACjD;;;;AAIA;EACE,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,2CAA2C;EAC3C,YAAY;EACZ,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;;;AAIA;AACA,gBAAgB;AAChB;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;AAChB;AACA;AACA,mBAAmB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;;AAGA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;;AAGA;;EAEE,mBAAmB;AACrB;;;;AAIA;;;;;;GAMG;;AAEH;;EAEE,UAAU;CACX,sBAAsB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;;EAGE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mDAAmD,EAAE,sCAAsC;EAC3F,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;;AAGA,kEAAkE;AAClE;EACE,qBAAqB,EAAE,mCAAmC;EAC1D,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;;AAGA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,sBAAsB;AACxB;;;;AAIA,gDAAgD;AAChD;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,iBAAiB,EAAE,gCAAgC;EACnD,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE,iBAAiB;AACnB;AACA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;;;AAIA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;;AAGA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;;AAGA,2BAA2B;AAC3B;EACE,yBAAyB,EAAE,0BAA0B;EACrD,WAAW,EAAE,cAAc;EAC3B,sBAAsB,EAAE,iBAAiB;AAC3C;;AAEA,iBAAiB;AACjB;EACE,yBAAyB,EAAE,yBAAyB;EACpD,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;AACf;;;AAGA;;EAEE,wCAAwC,EAAE,oCAAoC;EAC9E,gCAAgC,EAAE,4BAA4B;EAC9D,yBAAyB,EAAE,0BAA0B;AACvD;;;;AAIA;;EAEE,gBAAgB,EAAE,2BAA2B;EAC7C,iBAAiB,EAAE,iCAAiC;EACpD,kBAAkB,EAAE,2BAA2B;EAC/C,wCAAwC,EAAE,uBAAuB;EACjE,gBAAgB,EAAE,sCAAsC;EACxD,yBAAyB,EAAE,qBAAqB;AAClD;;AAEA;;GAEG;;AAEH;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,6CAA6C;IAC7C,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;EACf;;EAEA,4BAA4B;AAC9B;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;;AAGA,6BAA6B;AAC7B;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,gCAAgC;AAClC;;;AAGA,gCAAgC;AAChC;EACE,cAAc;EACd,UAAU;EACV,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,eAAe;EACf,gCAAgC;EAChC,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,gDAAgD;;;AAGhD,kBAAkB;AAClB;;;;;;;;;;;;;;;;GAgBG;AACH;;;;;;;;;;;;GAYG;;;;AAIH,2BAA2B;AAC3B;EACE,cAAc;EACd,UAAU;EACV,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,eAAe;EACf,gCAAgC;EAChC,cAAc;EACd,mBAAmB,EAAE,0BAA0B;AACjD;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;CAEC;;EAEC,UAAU;EACV,wBAAwB;EACxB,gCAAgC;AAClC;;;AAGA;EACE,gBAAgB;AAClB;;EAEE;IACE,4CAA4C;EAC9C,0BAA0B;IACxB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,qBAAqB;IACrB,iDAAiD;EACnD;;EAEA;IACE,qBAAqB;IACrB,+CAA+C;EACjD;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,cAAc,EAAE,4BAA4B;IAC5C,cAAc,EAAE,gCAAgC;IAChD,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,0CAA0C,EAAE,2BAA2B;IACvE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;GAEC;;MAEG,gBAAgB;IAClB;;AAEJ,0BAA0B;AAC1B;AACA,gCAAgC;AAChC;;AAEA;EACE,iCAAiC;AACnC;AACA;;EAEE,mDAAmD;EACnD,6BAA6B;AAC/B;AACA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,sDAAsD;EACtD,wCAAwC;EACxC,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;AACA,2CAA2C;EACzC,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,6CAA6C;EAC7C,mCAAmC;AACrC;;;;AAIA;;AAEA,4CAA4C;AAC5C,kCAAkC;AAClC;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,oDAAoD;EACpD,0CAA0C;EAC1C,oCAAoC;GACnC;AACH;;;;;GAKG;;;GAGA;;;KAGE,+DAA+D;KAC/D,qDAAqD;KACrD,2DAA2D,EAAE,aAAa;KAC1E,2BAA2B,EAAE,qCAAqC;CACtE;;;;;EAKC,2BAA2B","sourcesContent":["@import './background-colors.css';\r\n\r\n/* started RDMupload design */\r\n\r\nbutton.btn-download {\r\n    background-color: var(--download-btn-bg-color);\r\n    color: var(--download-btn-txt-color);\r\n    box-shadow: var(--button-box-shadow);\r\n}\r\n\r\nbutton.btn-preview {\r\n  background-color: var(--button-custom-one);\r\n  color: var(--whitefont-color);\r\n  box-shadow: var(--button-custom-one-shadow);\r\n}\r\n\r\nbutton.btn-reset-button {\r\n  background-color: var(--button-background);\r\n  color: var(--whitefont-color);\r\n  box-shadow: var(--button-box-shadow);\r\n}\r\n\r\n\r\n\r\nbutton.btn-preview:hover {\r\n  background-color: var(--button-custom-one-hover);\r\n  color: var(--whitefont-color);\r\n}\r\n\r\nbutton.btn-reset-button:hover {\r\n  background-color: var(--button-background);\r\n  color: var(--whitefont-color);\r\n}\r\n\r\n\r\nbutton.Upload-btn-color{\r\n  background-color: var(--Upload-btn-bg-color);\r\n  color: var(--Upload-btn-txt-color);\r\n}\r\n\r\n\r\nbutton.Upload-btn-color:hover{\r\n  background-color: var(--Upload-btn-bg-color);\r\n  color: var(--Upload-btn-txt-color);\r\n}\r\n\r\n\r\n\r\nbutton.btn-Upload {\r\n  background-color: var(--button-background);\r\n  color: var(--whitefont-color);\r\n  box-shadow: var(--button-box-shadow);\r\n}\r\n\r\n\r\nbutton.btn-cancel {\r\n  background-color: var(--button-custom-two-cancel);\r\n  color: var(--whitefont-color);\r\n  box-shadow: var(--button-custom-two-shadow);\r\n}\r\n\r\nbutton.btn-cancel:hover {\r\n  background-color: var(--button-custom-two-hover);\r\n  color: var(--whitefont-color);\r\n}\r\n\r\n.RDMupload-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 100vh;\r\n  justify-content: space-between; /* it will give space between header and footer */\r\n  background-color: #eaeaeb;\r\n}\r\n\r\n\r\n.container-upload {\r\n  background-color:  #FFFFFF;\r\n  padding: 5px;\r\n  border-radius: 10px;\r\n\r\n}\r\n\r\n/* .Demupload-card-header-1 {\r\n  background-color: #ffffff !important;\r\n  color: rgb(0, 0, 0);\r\n} */\r\n\r\n.breadcrumb-item + .breadcrumb-item::before {\r\n  content: \">\";\r\n  color: #6c757d; /* Optional: Adjust the color */\r\n}\r\n\r\n\r\n\r\n.text-color{\r\n  color: var(--Uplaod-h5-text-color);\r\n}\r\n\r\n.table-number-FS{\r\n  font-size: var(--table-number-font-size);\r\n}\r\n\r\n.checksum-details\r\n{\r\n  font-size:var(--checksum-deatils-font-size);\r\n  color:black ;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 1px;\r\n}\r\n\r\n\r\n\r\n.backbutton-uplaod{\r\nmargin-top: 10px;\r\n}\r\n\r\n.card-demupload {\r\n  height: 79vh;\r\n}\r\n\r\n\r\n.txt-margin-top{\r\n  margin-top: .7rem;\r\n  margin-left: 0.08rem;\r\n}\r\n\r\n.txt-margin-left{\r\n  /* margin-top: .7rem; */\r\n  margin-left: 0.05rem;\r\n  color: #0a66c2;\r\n}\r\n.down-btn-left{\r\nmargin-left: 0.3rem;\r\n}\r\n\r\n.browse-mar{\r\n  margin-left: 0.40rem;\r\n}\r\n\r\n\r\n.browse-mar1{\r\n  margin-left: 0.05rem;\r\n}\r\n.download-btn {\r\n  margin-left: 0.4rem;\r\n}\r\n\r\n.download-text-btn\r\n{\r\n  margin-left: 0.2rem;\r\n}\r\n\r\n\r\n.brow-box-btn\r\n{\r\n  margin-left: 0.3rem;\r\n}\r\n\r\n\r\n\r\n/* .vertical-line-border{\r\n\r\n  width: 2px; \r\n background-color: #ccc;\r\n  margin-Top: 20px;\r\n  margin-bottom: 11px; \r\n} */\r\n\r\n.vertical-line-border-1{\r\n\r\n  width: 2px; \r\n background-color: #ccc;\r\n  /* margin-Top: 20px; */\r\n  margin-bottom: 11px; \r\n  height: 400px;\r\n}\r\n\r\n.card-shawdow-demuplaod\r\n{\r\n\r\n  /* height: 58ch; */\r\n  background-color: #f9f9f9;\r\n  border-radius: 10px;\r\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075); /* Equivalent to Bootstrap shadow-sm */\r\n  border: none;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n\r\n/* Apply styles only within the \"supported-file-formats\" section */\r\n.supported-file-formats .format-item {\r\n  margin-bottom: 0.5rem; /* Equivalent to Bootstrap's mb-2 */\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n}\r\n\r\n\r\n.custom-vertical-line {\r\n  height: 100%;\r\n  width: 2px;\r\n  min-height: 460px;\r\n  background-color: #ccc;\r\n}\r\n\r\n\r\n\r\n/* Custom class for the overall upload section */\r\n.custom-upload-section {\r\n  display: flex;\r\n  width: 100%;\r\n  align-items: center;\r\n}\r\n\r\n/* Custom class for buttons container */\r\n.custom-upload-buttons {\r\n  margin-left: auto; /* Aligns buttons to the right */\r\n  text-align: end;\r\n}\r\n\r\n/* Custom class for cancel button */\r\n.custom-cancel-button {\r\n  margin-top: 8px;\r\n  text-align: end;\r\n}\r\n\r\n/* Optional: Add spacing between buttons */\r\n.custom-upload-buttons button {\r\n  margin-left: 10px;\r\n}\r\n/* Custom dropdown menu styles */\r\n.custom-dropdown-menu {\r\n  max-height: 80px;\r\n  overflow-y: auto;\r\n  min-width: 180px;\r\n}\r\n\r\n\r\n\r\n/* Container for the file upload */\r\n.custom-file-upload-container {\r\n  position: absolute;\r\n  top: 39%;\r\n  right: 315px;\r\n  z-index: 10;\r\n  width: 349px;\r\n  height: 140px;\r\n}\r\n\r\n\r\n.custom-file-upload-container-1 {\r\n  position: absolute;\r\n  top: 24%;\r\n  right: 315px;\r\n  z-index: 10;\r\n  width: 349px;\r\n  height: 140px;\r\n}\r\n\r\n/* Box styling for file upload */\r\n.custom-file-upload-box {\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 1rem;\r\n  border-radius: 8px;\r\n  background-color: #fff;\r\n  text-align: left;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Button styling */\r\n.custom-file-button {\r\n  max-width: 200px;\r\n}\r\n\r\n\r\n/* Custom dropdown button */\r\n.custom-dropdown-btn {\r\n  background-color: #f8f9fa; /* Light gray background */\r\n  color: #333; /* Dark text */\r\n  border: 1px solid #ccc; /* Light border */\r\n}\r\n\r\n/* Hover effect */\r\n.custom-dropdown-btn:hover {\r\n  background-color: #e9ecef; /* Slightly darker gray */\r\n  border-color: #bbb;\r\n}\r\n\r\n/* Disabled button styling */\r\n.custom-dropdown-btn:disabled {\r\n  background-color: #d6d6d6;\r\n  color: #888;\r\n  border-color: #d6d6d6;\r\n}\r\n\r\n/* Hide the actual file input */\r\n.custom-hidden-file-input {\r\n  display: none;\r\n}\r\n\r\n\r\n#noHoverDropdown:hover,\r\n#noHoverDropdown:focus {\r\n  background-color: transparent !important; /* Prevent background color change */\r\n  border-color: #6c757d !important; /* Keep the default border */\r\n  color: inherit !important; /* Retain the text color */\r\n}\r\n\r\n\r\n\r\n.Demuplad-custom-card{\r\n  \r\n  max-width: 900px; /* Adjust width as needed */\r\n  max-height: 450px; /* Adjust height to reduce size */\r\n  border-radius: 8px; /* Smooth rounded corners */\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Soft shadow effect */\r\n  overflow: hidden; /* Prevents content from overflowing */\r\n  background-color: #ffffff; /* White background */\r\n}\r\n\r\n/* .dem-header-name{\r\n  color: rgb(0, 0, 0);\r\n} */\r\n\r\n.wrapper {\r\n    margin: auto;\r\n    max-width: 400px;\r\n    padding-top: 60px;\r\n    text-align: center;\r\n  }\r\n  \r\n  .container {\r\n    padding: 0px;\r\n    border-radius: 10px;\r\n  }\r\n  \r\n  h1 {\r\n    color: #0f2d40;\r\n    /* font-family: 'Varela Round', sans-serif; */\r\n    letter-spacing: -.5px;\r\n    font-weight: 100;\r\n    padding-top:  10px;\r\n  }\r\n  \r\n  .upload-container {\r\n    background-color: rgb(239, 239, 239);\r\n    border-radius: 6px;\r\n    padding: 10px;\r\n  }\r\n\r\n  /* Custom Dropdown Styling */\r\n.custom-dropdown {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n\r\n/* Hide dropdown by default */\r\n.custom-dropdown-menu {\r\n  display: none;\r\n  position: absolute;\r\n  left: 83px;\r\n  background-color: white;\r\n  top: 1px;\r\n  border-radius: 6px;\r\n  min-width: 150px;\r\n  max-height: 110px;\r\n  border: 1px solid #ccc;\r\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n  padding: 4px 0;\r\n  list-style: none;\r\n  z-index: 1000;\r\n  transition: all 0.3s ease-in-out;\r\n}\r\n\r\n\r\n/* Show dropdown when hovering */\r\n.custom-dropdown:hover .custom-dropdown-menu {\r\n  display: block;\r\n  opacity: 1;\r\n  transform: translateY(-5px);\r\n}\r\n\r\n/* Dropdown Item Styling */\r\n.custom-dropdown-item {\r\n  background: none;\r\n  border: none;\r\n  padding: 5px 6px;\r\n  width: 100%;\r\n  text-align: left;\r\n  font-size: 10px;\r\n  color: #333;\r\n  cursor: pointer;\r\n  transition: background 0.3s ease;\r\n  display: block;\r\n}\r\n\r\n/* Hover Effect on Dropdown Items */\r\n.custom-dropdown-item:hover {\r\n  /* background: #26b7ec; */\r\n  color: rgb(0, 0, 0);\r\n  border-radius: 4px;\r\n}\r\n\r\n/* Custom Dropdown Styling for Sheet Selection */\r\n\r\n\r\n/* Dropdown Menu */\r\n/* .custom-dropdown-menu-sheet {\r\n  display: none;\r\n  position: absolute;\r\n  left: 83px;\r\n  background-color: white;\r\n  top: 5px;\r\n  border-radius: 6px;\r\n  min-width: 100%;\r\n  max-height: calc(5 * 22px); \r\n  overflow-y: auto; \r\n  border: 1px solid #ccc;\r\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n  padding: 0.5rem 0;\r\n  list-style: none;\r\n  z-index: 1000;\r\n  transition: all 0.3s ease-in-out;\r\n} */\r\n/* .custom-dropdown-menu-sheet {\r\n  position: absolute;\r\n  background-color: white;\r\n  border: 1px solid #ccc;\r\n  left: 83px;\r\n  top: 5px;\r\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);\r\n  padding: 0.5rem 0;\r\n  z-index: 1000;\r\n  width: fit-content; \r\n  min-width: 100%; \r\n  white-space: nowrap; \r\n} */\r\n\r\n\r\n\r\n/* Show dropdown on hover */\r\n.custom-dropdown-sheet:hover .custom-dropdown-menu-sheet {\r\n  display: block;\r\n  opacity: 1;\r\n  transform: translateY(-5px);\r\n}\r\n\r\n/* Dropdown Item Styling */\r\n.custom-dropdown-item-sheet {\r\n  background: none;\r\n  border: none;\r\n  padding: 4px 6px;\r\n  width: 100%;\r\n  text-align: left;\r\n  font-size: 10px;\r\n  color: #333;\r\n  cursor: pointer;\r\n  transition: background 0.3s ease;\r\n  display: block;\r\n  white-space: nowrap; /* Prevent text wrapping */\r\n}\r\n\r\n/* Hover Effect on Dropdown Items */\r\n.custom-dropdown-item-sheet:hover {\r\n  /* background: #26b7ec; */\r\n  color: rgb(0, 0, 0);\r\n  border-radius: 4px;\r\n}\r\n\r\n/* Custom Scrollbar */\r\n.custom-dropdown-menu-sheet::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.custom-dropdown-menu-sheet::-webkit-scrollbar-thumb {\r\n  /* background-color: #26b7ec; */\r\n  border-radius: 4px;\r\n}\r\n\r\n.custom-dropdown-menu-sheet::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n}\r\n\r\n .custom-dropdown-menu {\r\n\r\n  opacity: 1;\r\n  transform: translateY(0);\r\n  transition: all 0.3s ease-in-out;\r\n} \r\n\r\n\r\n.header-five{\r\n  margin-left: 4px;\r\n}\r\n  \r\n  .border-container {\r\n    border: 5px dashed rgba(198, 198, 198, 0.65);\r\n  /*   border-radius: 4px; */\r\n    padding: 1px;\r\n  }\r\n  \r\n  .border-container p {\r\n    color: #130f40;\r\n    font-weight: 600;\r\n    font-size: 1.1em;\r\n    letter-spacing: -1px;\r\n    margin-top: 30px;\r\n    margin-bottom: 0;\r\n    opacity: 0.65;\r\n  }\r\n  \r\n  #file-browser {\r\n    text-decoration: none;\r\n    color: rgb(22,42,255);\r\n    border-bottom: 3px dotted rgba(22, 22, 255, 0.85);\r\n  }\r\n  \r\n  #file-browser:hover {\r\n    color: rgb(0, 0, 255);\r\n    border-bottom: 3px dotted rgba(0, 0, 255, 0.85);\r\n  }\r\n  \r\n  .icons {\r\n    color: #95afc0;\r\n    opacity: 0.55;\r\n  }\r\n  \r\n  .selected-file {\r\n    color: #db34a3; /* Change color as desired */\r\n    font-size: 5px; /* Change font size as desired */\r\n    position: absolute;\r\n    top: 10%;\r\n    left: 10%;\r\n    transform: translate(-20%, -20%);\r\n  }\r\n  \r\n  .loading-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(255, 255, 255, 0.8); /* Semi-transparent white */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 9999;\r\n  }\r\n  \r\n   .foot-rdmup\r\n    {\r\n      margin-top: 20px;\r\n    }\r\n\r\n/* Preview Table design  */\r\n.table-name{\r\ncolor: var(--table-header-color);\r\n}\r\n\r\n.total-number{\r\n  color: var(--table-numbers-color);\r\n}\r\n.dropdown-button-color\r\n{\r\n  background-color: var(--dropdown-button-background);\r\n  color: var(--whitefont-color);\r\n}\r\n.columns-dropdown\r\n{\r\n  color: var(--blackfont-color);\r\n} \r\n\r\n.table-footer-color {\r\n  font-weight: bold !important;\r\n  background-color: var(--table-footer-color) !important;\r\n  color: var(--whitefont-color) !important;\r\n  text-align: right !important;\r\n  padding-right: 10px !important;\r\n}\r\n\r\n.table-footer-details {\r\nbackground-color: var(--table-footer-color);\r\n  position: sticky;\r\n  bottom: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.preview-btn-color\r\n{\r\n  background-color: var(--Preview-btn-bg-color);\r\n  color: var(--preview-btn-txt-color);\r\n}\r\n\r\n\r\n\r\n.cancel-btn-color\r\n{\r\nbackground-color: var(--cancel-btn-bg-color);  \r\ncolor: var(--cancel-btn-txt-color);\r\n}\r\n\r\n.Preview-table-name {\r\n  font-size: var(--table-name-font-size);\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n.validation-text{\r\n  color: green;\r\n  font-size: var(--preview-validation-font-size);\r\n  font-weight: bold;\r\n}\r\n\r\nbutton.Scan-preview-btn-color{\r\n  background-color: var(--ScanandPreview-btn-bg-color);\r\n  color: var(--Scanandpreview-btn-txt-color);\r\n  box-shadow: var(--button-box-shadow);\r\n   }\r\n/*  \r\n   button.Scan-preview-btn-color:hover {\r\n     background-color: var(--ScanandPreview-btn-bg-color);\r\n     color: var(--Scanandpreview-btn-txt-color);\r\n   }\r\n  */\r\n\r\n\r\n   button.Scan-preview-btn-color:hover,\r\n   button.Scan-preview-btn-color:active,\r\n   button.Scan-preview-btn-color:focus {\r\n     background-color: var(--ScanandPreview-btn-bg-color) !important;\r\n     color: var(--Scanandpreview-btn-txt-color) !important;\r\n     border-color: var(--ScanandPreview-btn-bg-color) !important; /* Optional */\r\n     box-shadow: none !important; /* Optional: removes Bootstrap glow */\r\n }\r\n \r\n\r\n\r\n\r\n  /* ended RDMupload design */\r\n  \r\n  \r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
